import * as React from "react";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { EsignatureSignedDocuments } from "../../../../../../../Wrap/Models/Models/Documents/InstructionDocuments/EsignatureSignedDocuments";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ESignaturePopupView } from "../../../NewBusinessWizard/Components/ESignature/ESignaturePopupView";
import { processTypeEnum } from "../../Resource/Contents";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";

interface IESignatureDocProps extends IProcessComponentProps {
    taskRequests: { fileName: string; taskRequestId: number }[];
    processType: processTypeEnum;
    customerData: FullClientDetailModel;
    isJointOrTrust: boolean;
    isJuniorSipp?: Boolean;
}

interface IESignatureDoc {
    selectAll: boolean;
    triggerred: number;
    signatureDocumentSigned: Array<EsignatureSignedDocuments>;
    isSubmitEsignatureSuccess: boolean;
    showESignatureView: boolean;
}

export class ESignatureDoc extends ProcessComponent<IESignatureDocProps, IESignatureDoc> {
    constructor(props: IESignatureDocProps) {
        super(props);
        this.state = {
            selectAll: false,
            triggerred: 0,
            signatureDocumentSigned: [],
            isSubmitEsignatureSuccess: false,
            showESignatureView: false,
        };
    }

    componentDidMount(): void {
        super.componentDidMount();
        let instructionId = 0;
        const parameters = getQueryParameters();
        const urlHierarchyId = parameters["id"];

        if (
            this.props.processType != processTypeEnum.NewBusiness &&
            this.props.processType != processTypeEnum.NewBusinessExistingClient
        ) {
            instructionId = HierarchyIdHelper.generateHierarchyId(urlHierarchyId).entityId;
        } else {
            instructionId = urlHierarchyId;
        }

        // InstructionDocumentTypeRequestTriggerActionsCreator.getSignedDocumentRequest(
        //     instructionId,
        //     (callBack: Array<EsignatureSignedDocuments>) => {
        //         this.setState({ signatureDocumentSigned: callBack });
        //     }
        // );
    }

    private renderElectricSignature() {
        return (
            <>
                <div className="mb-24">
                    {this.state.isSubmitEsignatureSuccess == false && (
                        <p>
                            <button
                                className="btn secondary"
                                onClick={() => this.setState({ showESignatureView: true })}
                            >
                                Select document(s)
                            </button>
                        </p>
                    )}
                </div>

                <ESignaturePopupView
                    showBox={this.state.showESignatureView}
                    fullClientDetail={this.props.customerData}
                    taskRequestList={this.props.taskRequests}
                    processType={this.props.processType}
                    isJuniorSipp={this.props.isJuniorSipp}
                    callBack={(isSubmitSuccess: boolean) => {
                        this.setState({ showESignatureView: false, isSubmitEsignatureSuccess: isSubmitSuccess });
                    }}
                />

                <hr />
            </>
        );
    }

    render() {
        return (
            <>
                {!this.props.isJointOrTrust && !(this.props.processType == processTypeEnum.RegularPayment && JsonDateParser.calculateAge(this.props.data.ClientDetails?.DateOfBirth) > 75) && (
                    <>
                        <h2>E-signature service</h2>
                        <p>
                            You can send any document that requires a client signature to your client electronically
                            using your e-signature service. <br />
                            You must generate at least one document allowed for e-signature before this service is
                            available.
                        </p>
                        {this.props.taskRequests.length > 0 &&
                            (this.props.processType == processTypeEnum.NewBusiness ||
                                this.props.processType == processTypeEnum.NewBusinessExistingClient ||
                                this.props.processType == processTypeEnum.SinglePaymentTransfer ||
                                this.props.processType == processTypeEnum.RegularPayment ||
                                this.props.processType == processTypeEnum.topUpWithITFLS) &&
                            this.renderElectricSignature()}
                    </>
                )}
            </>
        );
    }
}
